(() => {
  if (customElements.get('ximena-campaign-carousel')) return;

  class XimenaCampaignCarousel extends SlideshowComponent {
    static instances = new Set();

    constructor() {
      super();
      if (!this.slider || !this.nextButton || this.slider.dataset.autoplay !== 'true') return;

      this.campaignReady = true;
      this.visibleRatio = 0;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motionQuery.matches;
      this.motionOverride = false;
      this.autoplayButtonIsSetToPlay = !this.userPaused;
      this.togglePlayButtonState(this.userPaused);

      this.intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          this.visibleRatio = entry.intersectionRatio;
          XimenaCampaignCarousel.refresh();
        },
        { threshold: [0, 0.2, 0.5, 0.75, 1] }
      );
      this.intersectionObserver.observe(this);
      this.motionQuery.addEventListener('change', () => {
        if (this.motionQuery.matches) {
          this.userPaused = true;
          this.motionOverride = false;
          this.autoplayButtonIsSetToPlay = false;
          this.togglePlayButtonState(true);
        }
        XimenaCampaignCarousel.refresh();
      });

      XimenaCampaignCarousel.instances.add(this);
      if (!XimenaCampaignCarousel.visibilityListener) {
        document.addEventListener('visibilitychange', () => XimenaCampaignCarousel.refresh());
        XimenaCampaignCarousel.visibilityListener = true;
      }
    }

    disconnectedCallback() {
      this.intersectionObserver?.disconnect();
      XimenaCampaignCarousel.instances.delete(this);
      XimenaCampaignCarousel.refresh();
    }

    static refresh() {
      const winner = [...this.instances]
        .filter((carousel) => carousel.visibleRatio >= 0.2)
        .sort((a, b) => b.visibleRatio - a.visibleRatio)[0];

      for (const carousel of this.instances) {
        carousel.isActiveCarousel = carousel === winner;
        carousel.syncAutoplay();
      }
    }

    canPlay() {
      const motionAllowed = !this.motionQuery.matches || this.motionOverride;
      return this.isActiveCarousel && !document.hidden && !this.userPaused && motionAllowed;
    }

    syncAutoplay() {
      this.canPlay() ? super.play() : super.pause();
    }

    play() {
      this.campaignReady && this.canPlay() ? super.play() : super.pause();
    }

    autoPlayToggle() {
      this.userPaused = !this.userPaused;
      this.motionOverride = this.motionQuery.matches && !this.userPaused;
      this.autoplayButtonIsSetToPlay = !this.userPaused;
      this.togglePlayButtonState(this.userPaused);
      this.syncAutoplay();
    }

    autoRotateSlides() {
      const nextPosition = this.currentPage >= this.totalPages ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
      this.setSlidePosition(nextPosition);
    }
  }

  customElements.define('ximena-campaign-carousel', XimenaCampaignCarousel);
})();
